import { createReducer, on } from '@ngrx/store';

import { initialTemplateState } from './indTemplate.state';
import { IndTemplateActions } from './indTemplate.actions';

export const indTemplateReducer = createReducer(
  initialTemplateState,

  // reset store to initial value
  on(IndTemplateActions.resetStore, () => initialTemplateState),

  on(IndTemplateActions.loadTemplate, (state, { measureOId }) => ({
    ...state,
    loading: true,
    error: null,
    selectedSurveyOid: measureOId,
  })),

  on(IndTemplateActions.loadTemplateSuccess, (state, { template }) => ({
    ...state,
    loading: false,
    template,
  })),

  on(IndTemplateActions.loadTemplateFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(IndTemplateActions.updateTemplateDomain, (state, { updatedDomain }) => {
    if (!state.template || !state.template.domains) {
      return state;
    }

    return {
      ...state,
      template: {
        ...state.template,
        domains: state.template.domains.map((domain) =>
          domain.idobject === updatedDomain.idobject
            ? {
                ...domain,
                ...updatedDomain,
                scales: updatedDomain.scales ?? domain.scales,
              }
            : domain,
        ),
      },
    };
  }),
  on(IndTemplateActions.updateTemplateScale, (state, { updatedScale }) => {
    if (!state.template || !state.template.domains) {
      return state;
    }

    return {
      ...state,
      template: {
        ...state.template,
        domains: state.template.domains.map((domain) => {
          const hasScale = domain.scales.some((s) => s.idobject === updatedScale.idobject);
          if (!hasScale) {
            return domain;
          }

          return {
            ...domain,
            scales: domain.scales.map((scale) => {
              if (scale.idobject !== updatedScale.idobject) {
                return scale;
              }

              return {
                ...updatedScale,
                items: updatedScale.items ?? scale.items,
              };
            }),
          };
        }),
      },
    };
  }),
  on(IndTemplateActions.updateTemplateScaleItem, (state, { updatedItem }) => {
    if (!state.template || !state.template.domains) {
      return state;
    }

    return {
      ...state,
      template: {
        ...state.template,
        domains: state.template.domains.map((domain) => {
          const hasItem = domain.scales.some((scale) =>
            scale.items?.some((item) => item.idobject === updatedItem.idobject),
          );

          if (!hasItem) {
            return domain;
          }

          return {
            ...domain,
            scales: domain.scales.map((scale) => {
              const hasItemInScale = scale.items?.some((item) => item.idobject === updatedItem.idobject);
              if (!hasItemInScale) {
                return scale;
              }

              return {
                ...scale,
                items: scale.items.map((item) => (item.idobject === updatedItem.idobject ? updatedItem : item)),
              };
            }),
          };
        }),
      },
    };
  }),

  on(IndTemplateActions.updateTemplateBuilderPage, (state, { data: scoreConfiguration }) => {
    if (!state.template) {
      return state;
    }

    return {
      ...state,
      template: {
        ...state.template,
        ...scoreConfiguration,
      },
    };
  }),
);
